import React from 'react';
import { Box, Text } from '@myob/myob-widgets';
import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import style from './PricingMolecule.common.module.scss';
import { PricingMoleculeProps } from './types';

export const PricingMoleculeCommon: React.FC<PricingMoleculeProps> =
  ({
    price,
    productDisplayName = ''
  }) => {
    const { promoCode, promotionEndDate } = useSessionContext();

    return (
      <Box
        className={style.pricingMolecule}
        data-testid='pricing-molecule'
        display='flex'
        justifyContent='space-between'
        alignItems='flex-start'
      >
        <Text
          className={style.productName}
          as='span'
          tone='neutralStrongest'
        >
          {productDisplayName}
        </Text>
        <Box
          display='flex'
          alignItems='end'
          className={style.priceGroup}
        >
          <Text
            className={style.priceAmount}
            as='span'
            tone='neutralStrongest'
          >
            ${price}
          </Text>
          <Text
            className={style.priceSchedule}
            as='span'
            tone='neutralStrongest'
          >
            /month{promoCode && promotionEndDate ? '^' : ''}
          </Text>
        </Box>
      </Box>
    );
  };
